import { CSSProperties, MouseEvent } from 'react';

type TColWidth = `${number}${'px' | '%'}`;

export enum ERowColor {
  GRAY = 'gray',
  RED = 'red',
  GREEN = 'green',
  BLUE = 'blue',
  WHITE = 'white',
}

export interface ITableColumn<C extends string, S = string> {
  key: C;
  caption?: string;
  width?: TColWidth;
  sortingValue?: S;
}

export type TCellRender<
  ItemType,
  C extends string = keyof ItemType & string,
> = Partial<Record<C, (data: ItemType) => React.ReactElement>>;

export type TRowStyles<ItemType> = (row: ItemType) => CSSProperties;

export enum ESort {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ISorting<T> {
  mode: ESort;
  value?: T;
}

type TRowColorSelector<ItemType> = (item: ItemType) => ERowColor;

export interface ITableProps<
  ItemType,
  C extends string = keyof ItemType & string,
  S = string
> {
  defaultCellRender?: (item: ItemType, key: C | string) => React.ReactNode;
  children?: (item: ItemType, key: C) => React.ReactNode;
  isSortable?: boolean;
  columns: ITableColumn<C | string, S>[];
  list: ItemType[];
  cellRender?: TCellRender<ItemType, C | string>;
  rowStyles?: TRowStyles<ItemType>;
  onSort?: (sort: ISorting<S> | null) => void;
  onRowClick?: (item: ItemType, e: MouseEvent) => void;
  rowColor?: TRowColorSelector<ItemType>;
  isLoading?: boolean;
  isSticky?: boolean;
  stickyOffset?: string;
}

export interface ITableHeadStyledProps {
  $stickyOffset: string;
  $isSticky: boolean;
}

export interface ISortingIndicatorProps {
  order?: ESort;
}

export interface ISortingIndicatorStyledProps {
  $order?: ESort;
}
